
export const overallBalanceConfig: OverallBalanceConfig = {
  title: "Overall Balance",
  amount: "$2,538,942",
  trend: "+16.3% last 12 months",
  trendPercent: 16.3,
  chartData: [
    { month: "Jan", orders: 1800, expenses: 1200 },
    { month: "Feb", orders: 2200, expenses: 1400 },
    { month: "Mar", orders: 1900, expenses: 1600 },
    { month: "Apr", orders: 2800, expenses: 1500 },
    { month: "May", orders: 2400, expenses: 1800 },
    { month: "Jun", orders: 3200, expenses: 1700 },
    { month: "July", orders: 2900, expenses: 1900 },
  ],
  quickStats: [
    {
      id: "sales",
      label: "Total Sales",
      value: "$14,673",
      iconName: "shopping-bag",
      bg: "bg-yellow-soft",
      color: "text-yellow",
    },
    {
      id: "profit",
      label: "Total Profit",
      value: "$9,281",
      iconName: "dollar",
      bg: "bg-pink-soft",
      color: "text-pink",
    },
    {
      id: "users",
      label: "Total Users",
      value: "45.1k",
      iconName: "users",
      bg: "bg-teal-soft",
      color: "text-teal",
    },
    {
      id: "expense",
      label: "Total Expense",
      value: "$4,673",
      iconName: "wallet",
      bg: "bg-primary-soft",
      color: "text-primary",
    },
  ],
};
